module.exports = __webpack_public_path__ + "img/schedule_introduction.6f8bb55b.svg";